import { render, staticRenderFns } from "./PendingTransactions.vue?vue&type=template&id=6802d08a&"
import script from "./PendingTransactions.vue?vue&type=script&lang=js&"
export * from "./PendingTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports